/*
 * @Author: Gaho
 * @Date: 2024-01-12 15:46:41
 * @LastEditors: Gaho
 * @LastEditTime: 2024-03-25 16:08:54
 */
export class Space {
    container: any;
    convasContent: any;
    stars: Array<any>; // 星星
    numStars: number; // 星星数量
    focalLength: number; // 焦距
    warp: number; 
    centerX: number; // 画布中心点x轴坐标
    centerY: number; // 画布中心点y轴坐标
    radius: string; // 半径
    speed: number; // 星星移动速度
    constructor(container) {
        this.container = container;
        this.convasContent = container == null ? undefined : container.getContext("2d");
        this.stars = [];
        this.numStars = 200;
        for (let i = 0; i < this.numStars; i++) {
            this.stars.push({
                x: Math.random() * (container == null ? undefined : container.width),
                y: Math.random() * (container == null ? undefined : container.height),
                z: Math.random() * (container == null ? undefined : container.width),
                o: "0." + Math.floor(Math.random() * 99) + 1
            });
        }
        this.focalLength = (container == null ? undefined : container.width) * 0.9;
        this.warp = 0;
        this.centerX = (container == null ? undefined : container.width) / 2;
        this.centerY = (container == null ? undefined : container.height) / 2;
        this.radius = "0." + Math.floor(Math.random() * 9) + 1;
        this.speed = 0.8;
    }
    /**
     * 星星运动
     */
    moveStars() {
        for (let i = 0; i < this.numStars; i++) {
            const star = this.stars[i];
            star.z -= this.speed;
            if (star.z <= 0) {
                star.z = this.container.width;
            }
        }
    }/**
     * 绘制星星
     */
    drawStars() {
        let pixelX, pixelY, pixelRadius;
        const { convasContent, container, centerX, centerY, focalLength } = this;
        if(!convasContent) return;
        convasContent.clearRect(0, 0, container.width, container.height);
        convasContent.fillStyle = "rgba(209, 255, 255, " + this.radius + ")";
        for (let i = 0; i < this.numStars; i++) {
            const star = this.stars[i];
            pixelX = (star.x - centerX) * (focalLength / star.z);
            pixelX += centerX;
            pixelY = (star.y - centerY) * (focalLength / star.z);
            pixelY += centerY;
            pixelRadius = 1 * (focalLength / star.z);
            convasContent.beginPath();
            convasContent.arc(pixelX, pixelY, pixelRadius, 0, Math.PI * 2, false);
            convasContent.fillStyle = "rgba(209, 255, 255, " + star.o + ")";
            convasContent.fill();
        }
    }
    /**
     * 绘制图片
     * @param image img refs
     * @param x 位置-横坐标
     * @param y 位置-纵坐标
     * @param scale 大小缩放
     */
    drawImage(image, x = this.centerX, y = this.centerY, scale = 0.77) {
        const { convasContent } = this;
        if(!convasContent) return;
        convasContent.setTransform(scale, 0, 0, scale, x, y);
        convasContent.rotate(0);
        convasContent.drawImage(image, -image.width / 2, -image.height / 2);
        convasContent.setTransform(1, 0, 0, 1, 0, 0);
    }
    /**
     * 
     * @param atlas img refs
     * @param current 
     * @param x 
     * @param y 
     * @param scale 缩放大小
     * @param rotation 旋转角度
     */
    drawAtlas(atlas, current, x = 900, y = 900, scale = 1, rotation = 0) {
        const { convasContent } = this;
        convasContent.setTransform(scale, 0, 0, scale, x, y);
        convasContent.rotate(rotation * Math.PI / 180);
        convasContent.drawImage(
            atlas,
            current.x,
            current.y,
            current.w,
            current.h,
            -current.w / 2,
            -current.h / 2,
            current.w,
            current.h
        );
        convasContent.setTransform(1, 0, 0, 1, 0, 0);
    }
}
export class SpriteMovie {
    singWidth: number;
    singHeight: number;
    totalFrames: number;
    frames: Array<any>;
    currentFrame: number;
    endFun: Function; // 回调
    delta: number;
    atlas: any; // 要绘制在canvas上的图片
    rotation: number;
    cWidth: number;
    cHeight: number;
    ctx: any; // canvas实例
    isAnimate: boolean; // 是否开启动画
    x: number;
    y: number;
    constructor(cWidth: number, cHeight: number, atlas: any, callback: () => {}, canvas: any) {
        this.singWidth = (atlas == null ? undefined : atlas.width) / cWidth;
        this.singHeight = (atlas == null ? undefined : atlas.height) / cHeight;
        this.totalFrames = cWidth * cHeight - 1;
        this.frames = [];
        this.currentFrame = 0;
        this.cWidth = cWidth;
        this.cHeight = cHeight;
        this.atlas = atlas;
        this.x = this.singWidth;
        this.y = this.singHeight;
        this.rotation = 0;
        this.atlas = atlas;
        for (let i = 0; i < this.totalFrames; i++) {
            this.frames[i] = this.getFrame(i);
        }
        this.endFun = callback;
        this.delta = 0;
        this.ctx = canvas == null ? undefined : canvas.getContext("2d");
        this.isAnimate = false;
    }
    update() {
        if (!this.isAnimate) {
            return;
        }
        const { ctx } = this;
        if (++this.delta > 2) {
            this.delta = 0;
            if (++this.currentFrame >= this.totalFrames) {
                this.currentFrame = 0;
                this.endFun(); 
            }
        }
        const { x, y, atlas } = this;
        // 矩阵变换重置当前坐标系
        ctx.setTransform(1, 0, 0, 1, x, y);
        const current = this.frames[this.currentFrame];
        
        // 规划一片区域，将图片绘制在这片区域内
        ctx.drawImage(
            atlas,
            current.x, // 区域的位置-左上角横坐标
            current.y, // 区域的位置-左上角纵坐标
            current.w, // 区域的宽度
            current.h, // 区域的高度
            -current.w / 2, // 图片绘制的位置-起始横坐标
            -current.h / 2, // 图片绘制的位置-起始纵坐标
            current.w, // 从坐标点开始计算，绘制的图片宽度
            current.h // 从坐标点开始计算，绘制的图片高度
        );
        ctx.setTransform(1, 0, 0, 1, 0, 0);
    }
    getFrame(id: number) {
        const x = id % this.cWidth;
        const y = Math.trunc(id / this.cWidth);
        return {
            w: this.singWidth,
            h: this.singHeight,
            x: x * this.singWidth,
            y: y * this.singHeight
        };
    }
}